import React, { useState, useEffect, useCallback } from 'react';
import { getSegments, toggleSegment, sendCommunication } from '../services/api';
import { AdminThemeContext, ADMIN_THEMES, injectAdminThemeVars, getAdminStyles } from './adminTheme';
import SqOffOrders from './SqOffOrders';
import ClientAlerts from './ClientAlerts';
import OrderReports from './OrderReports';
import DealerAccessPanel from './DealerAccessPanel';
import AuditLogs from './AuditLogs';
import UserManagement from './UserManagement';
import BFUpload from './BFUpload';
import ClientUpload from './ClientUpload';
import SystemLogsPanel from './SystemLogsPanel';
import SyncMonitor from './SyncMonitor';

/* ── Navia logo ───────────────────────────────────────────────────────────── */
const NAVIA_LOGO = 'data:image/png;base64,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';

/* ── Google Font ─────────────────────────────────────────────────────────── */
(function() {
  if (!document.head.querySelector('[href*="DM+Sans"]')) {
    const l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap';
    document.head.appendChild(l);
  }
})();

/* ── Real-time polling notifications ─────────────────────────────────────── */
function useOrderNotifications(onNewOrder) {
  const lastPollRef = React.useRef(null);
  useEffect(() => {
    const token = localStorage.getItem('nb_admin_token');
    if (!token) return;
    const authH = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
    const poll = async () => {
      try {
        const params = lastPollRef.current ? `?since=${encodeURIComponent(lastPollRef.current)}` : '';
        const res    = await fetch(`/api/admin/notifications/pending${params}`, { headers: authH });
        if (res.status === 401) {
            // Session expired — redirect to login (interval clears on unmount)
            window.location.href = '/admin';
            return;
        }
        if (!res.ok) return;
        const data = await res.json();
        if (data.alerts && data.alerts.length > 0) {
          lastPollRef.current = new Date().toISOString();
          data.alerts.forEach(alert => onNewOrder(alert));
          try {
            const ctx = new (window.AudioContext || window.webkitAudioContext)();
            [660, 880, 1100].forEach((freq, i) => {
              const osc  = ctx.createOscillator();
              const gain = ctx.createGain();
              osc.connect(gain); gain.connect(ctx.destination);
              osc.frequency.value = freq; osc.type = 'sine';
              gain.gain.setValueAtTime(0.25, ctx.currentTime + i * 0.18);
              gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + i * 0.18 + 0.15);
              osc.start(ctx.currentTime + i * 0.18);
              osc.stop(ctx.currentTime + i * 0.18 + 0.15);
            });
          } catch(_) {}
        }
      } catch(_) {}
    };
    poll();
    const iv = setInterval(poll, 5000);
    return () => clearInterval(iv);
  }, [onNewOrder]);
}

/* ── Alert Banner ─────────────────────────────────────────────────────────── */
function OrderAlertBanner({ alerts, onDismiss, onViewOrders }) {
  if (alerts.length === 0) return null;
  const latest = alerts[alerts.length - 1];
  return (
    <div style={{ position:'fixed', top:0, left:200, right:0, zIndex:99999, background:'linear-gradient(90deg,#dc2626,#b91c1c)', color:'#fff', padding:'0 24px', display:'flex', alignItems:'center', justifyContent:'space-between', fontFamily:"'DM Sans',sans-serif", boxShadow:'0 4px 24px rgba(220,38,38,.5)', animation:'nbAlertSlide .25s ease' }}>
      <style>{`@keyframes nbAlertSlide{from{transform:translateY(-100%)}to{transform:translateY(0)}} @keyframes nbPulse{0%,100%{opacity:1}50%{opacity:.6}} .nb-pulse{animation:nbPulse 1s ease infinite}`}</style>
      <div style={{ display:'flex', alignItems:'center', gap:16, padding:'12px 0' }}>
        <span className="nb-pulse" style={{ fontSize:24 }}>🚨</span>
        <div>
          <div style={{ fontSize:14, fontWeight:700 }}>NEW SQ-OFF — <span style={{ background:'rgba(255,255,255,.2)', borderRadius:5, padding:'2px 10px', marginLeft:4 }}>{latest.symbol}</span> · <span style={{ fontSize:12, opacity:.85 }}>{latest.exchange}/{latest.segment}</span></div>
          <div style={{ fontSize:12, opacity:.85, marginTop:3, display:'flex', gap:14 }}>
            <span>UCC: <strong>{latest.ucc}</strong></span>
            <span style={{ color:latest.side==='SELL'?'#fca5a5':'#86efac' }}>{latest.side} {latest.quantity}</span>
            <span>{new Date(latest.timestamp).toLocaleTimeString('en-IN', {hour:'2-digit',minute:'2-digit',second:'2-digit'})}</span>
            {alerts.length > 1 && <span style={{ background:'rgba(255,255,255,.25)', borderRadius:99, padding:'1px 9px', fontSize:11 }}>+{alerts.length-1} more</span>}
          </div>
        </div>
      </div>
      <div style={{ display:'flex', gap:10, padding:'12px 0', flexShrink:0 }}>
        <button onClick={onViewOrders} style={{ background:'#fff', color:'#dc2626', border:'none', borderRadius:7, padding:'8px 18px', fontSize:13, fontWeight:700, cursor:'pointer' }}>⚡ Process Order</button>
        <button onClick={onDismiss} style={{ background:'transparent', color:'rgba(255,255,255,.8)', border:'1px solid rgba(255,255,255,.35)', borderRadius:7, padding:'8px 14px', fontSize:12, cursor:'pointer' }}>Dismiss</button>
      </div>
    </div>
  );
}

/* ── Constants ────────────────────────────────────────────────────────────── */
const SEGMENTS = {
  NSE: [{ segment:'CM', name:'Cash Market', code:'NSE · CM' }, { segment:'FO', name:'Futures & Options', code:'NSE · FO' }],
  BSE: [{ segment:'CM', name:'Cash Market', code:'BSE · CM' }, { segment:'FO', name:'Futures & Options', code:'BSE · FO' }],
  MCX: [{ segment:'FO', name:'Futures & Options', code:'MCX · FO' }],
};
const EX_COLORS = {
  NSE: { bg:'#eff6ff', col:'#1d4ed8', bdr:'#bfdbfe' },
  BSE: { bg:'#f0fdf4', col:'#15803d', bdr:'#bbf7d0' },
  MCX: { bg:'#fff7ed', col:'#c2410c', bdr:'#fed7aa' },
};
const NAV_ITEMS = [
  { label:'Segment Control', key:'segments', section:'Control'    },
  { label:'Sq-Off Orders',   key:'orders',   section:'Control'    },
  { label:'Client Alerts',   key:'alerts',   section:'Control'    },
  { label:'B/F Upload',      key:'bfupload', section:'Operations' },
  { label:'Sync Monitor',    key:'syncmon',  section:'Operations' },
  { label:'Order Reports',   key:'reports',  section:'Reports'    },
  { label:'Dealer Access',   key:'dealer',   section:'Reports'    },
  { label:'Audit Logs',      key:'logs',     section:'Reports'    },
  { label:'System Logs',     key:'syslogs',  section:'Reports'    },
  { label:'User Management', key:'users',    section:'Admin'      },
  { label:'Client Upload',   key:'clients',  section:'Admin'      },
];

/* ── Sidebar ──────────────────────────────────────────────────────────────── */
function Sidebar({ activeNav, onNav, admin, onLogout, pendingCount, T }) {
  const sections = ['Control','Operations','Reports','Admin'];
  return (
    <div style={{ position:'fixed', left:0, top:0, bottom:0, width:210, background:T.sidebar, display:'flex', flexDirection:'column', fontFamily:"'DM Sans',sans-serif", zIndex:100, borderRight:`0.5px solid rgba(255,255,255,0.06)` }}>
      {/* Logo */}
      <div style={{ padding:'16px', borderBottom:'0.5px solid rgba(255,255,255,0.07)', display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ background:'#fff', borderRadius:8, padding:'4px 10px', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 1px 4px rgba(0,0,0,.2)' }}>
          <img src={NAVIA_LOGO} style={{ height:20, width:'auto', objectFit:'contain' }} alt="Navia"/>
        </div>
        <div>
          <div style={{ color:'#fff', fontSize:12, fontWeight:600 }}>Navia Backup</div>
          <div style={{ color:'rgba(255,255,255,.35)', fontSize:10 }}>RMS Portal</div>
        </div>
      </div>
      {/* Nav */}
      <div style={{ flex:1, overflowY:'auto', padding:'10px 0' }}>
        {sections.map(section => (
          <div key={section}>
            <div style={{ color:'rgba(255,255,255,.25)', fontSize:9, fontWeight:600, letterSpacing:1.2, padding:'10px 16px 4px', textTransform:'uppercase' }}>{section}</div>
            {NAV_ITEMS.filter(n => n.section === section).map(item => (
              <div key={item.key} onClick={() => onNav(item.key)}
                style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 16px', cursor:'pointer', color: activeNav===item.key?'#fff':'rgba(255,255,255,.45)', background: activeNav===item.key?T.sidebarActive:'transparent', borderLeft:`2px solid ${activeNav===item.key?T.brand:'transparent'}`, fontSize:12, transition:'all .15s', fontFamily:"'DM Sans',sans-serif" }}>
                <div style={{ width:5, height:5, borderRadius:'50%', background: activeNav===item.key?T.brand:'rgba(255,255,255,.2)', flexShrink:0 }}/>
                {item.label}
                {item.key==='orders' && pendingCount>0 && (
                  <span style={{ marginLeft:'auto', background:'#dc2626', color:'#fff', fontSize:9, fontWeight:700, padding:'2px 7px', borderRadius:99 }}>{pendingCount}</span>
                )}
                {item.key==='bfupload' && (
                  <span style={{ marginLeft:'auto', background:'rgba(251,191,36,.2)', color:'#fbbf24', fontSize:8, fontWeight:700, padding:'1px 5px', borderRadius:3 }}>RMS</span>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
      {/* Footer */}
      <div style={{ padding:'12px 16px', borderTop:'0.5px solid rgba(255,255,255,.07)' }}>
        <div style={{ fontSize:11, color:'rgba(255,255,255,.5)', marginBottom:1 }}>{admin.name}</div>
        <div style={{ fontSize:10, color:'rgba(255,255,255,.25)', marginBottom:8 }}>{admin.role}</div>
        <button onClick={onLogout} style={{ width:'100%', padding:'6px', borderRadius:6, border:'0.5px solid rgba(255,255,255,.12)', background:'transparent', color:'rgba(255,255,255,.35)', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Sign Out</button>
      </div>
    </div>
  );
}

/* ── Topbar ───────────────────────────────────────────────────────────────── */
function Topbar({ title, subtitle, admin, T, themeKey, toggleTheme }) {
  return (
    <div style={{ background:T.topbar, borderBottom:`0.5px solid ${T.bdr}`, padding:'0 24px', height:52, display:'flex', alignItems:'center', justifyContent:'space-between', fontFamily:"'DM Sans',sans-serif", boxShadow:T.shadow }}>
      <div>
        <div style={{ fontSize:14, fontWeight:600, color:T.tx }}>{title}</div>
        {subtitle && <div style={{ fontSize:11, color:T.tx2, marginTop:1 }}>{subtitle}</div>}
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:12 }}>
        {/* Theme toggle */}
        <button onClick={toggleTheme}
          style={{ width:34, height:34, borderRadius:'50%', background:T.surf2, border:`0.5px solid ${T.bdr}`, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15 }}>
          {themeKey==='light'?'🌙':'☀'}
        </button>
        <span style={{ background:T.brandL, color:T.brand, border:`0.5px solid ${T.brand}`, padding:'3px 8px', borderRadius:4, fontSize:10, fontWeight:600 }}>{admin.role}</span>
        <span style={{ fontSize:12, color:T.tx2 }}>{admin.name}</span>
        <div style={{ width:30, height:30, borderRadius:'50%', background:T.brand, color:'#fff', fontSize:11, fontWeight:600, display:'flex', alignItems:'center', justifyContent:'center' }}>{admin.name[0]}</div>
      </div>
    </div>
  );
}

/* ── Segment Control Panel ────────────────────────────────────────────────── */
function SegmentControl({ segments, onToggle, onAlert, toggling, communicating, T }) {
  const [activeEx, setActiveEx] = useState('NSE');
  const S = getAdminStyles(T);
  const enabled = segments.filter(s => s.is_enabled).length;

  return (
    <div>
      {/* Stat cards */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 }}>
        {[
          { label:'Total Segments',  value:segments.length,        color:T.brand },
          { label:'Active',          value:enabled,                color:T.ok    },
          { label:'Inactive',        value:segments.length-enabled, color:T.err  },
          { label:"Today's Orders",  value:0,                      color:T.warn  },
        ].map(c => (
          <div key={c.label} style={{ ...S.statCard }}>
            <div style={{ ...S.statLabel }}>{c.label}</div>
            <div style={{ ...S.statNum(c.color) }}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* Platform status bar */}
      <div style={{ background:T.warnBg, border:`0.5px solid ${T.warn}`, borderRadius:8, padding:'10px 16px', marginBottom:16, display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ width:6, height:6, borderRadius:'50%', background:T.warn, flexShrink:0 }}/>
        <span style={{ fontSize:12, color:T.warnTx }}>Platform monitoring active · {segments.filter(s=>s.is_enabled).length} of {segments.length} segments enabled</span>
        <button onClick={()=>window.location.reload()} style={{ marginLeft:'auto', ...S.btnGhost, fontSize:11, padding:'4px 12px' }}>↻ Refresh</button>
      </div>

      {/* Segment panel */}
      <div style={{ ...S.card }}>
        {/* Exchange tabs */}
        <div style={{ display:'flex', borderBottom:`0.5px solid ${T.bdr}` }}>
          {['NSE','BSE','MCX'].map(ex => {
            const exSegs = segments.filter(s => s.exchange===ex);
            const actCnt = exSegs.filter(s => s.is_enabled).length;
            const ec = EX_COLORS[ex];
            return (
              <div key={ex} onClick={()=>setActiveEx(ex)}
                style={{ padding:'10px 24px', cursor:'pointer', fontSize:13, fontWeight:500, color:activeEx===ex?T.brand:T.tx2, borderBottom:`2px solid ${activeEx===ex?T.brand:'transparent'}`, background:activeEx===ex?T.brandL:'transparent', display:'flex', alignItems:'center', gap:8, transition:'all .15s' }}>
                <span style={{ ...S.badge(ec.bg, ec.col, ec.bdr) }}>{ex}</span>
                {actCnt>0 && <span style={{ ...S.pill(T.okBg, T.ok) }}>{actCnt} active</span>}
              </div>
            );
          })}
        </div>
        {/* Table header */}
        <div style={{ display:'grid', gridTemplateColumns:'2fr 100px 130px 150px 200px', padding:'9px 20px', background:T.surf2, borderBottom:`0.5px solid ${T.bdr}` }}>
          {['Segment','Type','Status','Last Updated','Actions'].map(h=>(
            <div key={h} style={{ fontSize:10, color:T.tx2, fontWeight:600, textTransform:'uppercase', letterSpacing:.4 }}>{h}</div>
          ))}
        </div>
        {/* Segment rows */}
        {SEGMENTS[activeEx].map((seg, i) => {
          const data = segments.find(s=>s.exchange===activeEx&&s.segment===seg.segment)||{};
          const key  = `${activeEx}-${seg.segment}`;
          const on   = data.is_enabled;
          const upd  = data.enabled_at ? new Date(data.enabled_at).toLocaleString('en-IN',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'}) : '—';
          const ec   = EX_COLORS[activeEx];
          return (
            <div key={key} style={{ display:'grid', gridTemplateColumns:'2fr 100px 130px 150px 200px', padding:'13px 20px', alignItems:'center', borderBottom: i<SEGMENTS[activeEx].length-1?`0.5px solid ${T.bdr}`:'none', background:on?T.brandL:T.surf }}>
              <div>
                <div style={{ fontSize:13, fontWeight:500, color:T.tx }}>{seg.name}</div>
                <div style={{ fontSize:10, color:T.tx3, marginTop:2 }}>{seg.code}</div>
              </div>
              <div><span style={{ ...S.badge(ec.bg,ec.col,ec.bdr) }}>{seg.segment}</span></div>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <div style={{ width:7, height:7, borderRadius:'50%', background:on?'#16a34a':'#d1d5db' }}/>
                <span style={{ fontSize:12, fontWeight:500, color:on?T.ok:T.tx3 }}>{on?'Active':'Inactive'}</span>
              </div>
              <div style={{ fontSize:11, color:T.tx2 }}>{upd}</div>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={()=>onAlert(activeEx,seg.segment)} disabled={communicating[key]}
                  style={{ ...S.btnGhost, fontSize:11, padding:'5px 12px', opacity:communicating[key]?.6:1 }}>
                  {communicating[key]?'Sending...':'📢 Alert Clients'}
                </button>
                <button onClick={()=>onToggle(activeEx,seg.segment,on)} disabled={toggling[key]}
                  style={{ padding:'5px 14px', borderRadius:5, border:`0.5px solid ${on?T.err:T.ok}`, background:on?T.errBg:T.okBg, color:on?T.err:T.ok, fontSize:11, fontWeight:500, cursor:toggling[key]?'not-allowed':'pointer', fontFamily:"'DM Sans',sans-serif", opacity:toggling[key]?.6:1 }}>
                  {toggling[key]?'...':on?'Disable':'Enable'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ══ MAIN AdminDashboard ══════════════════════════════════════════════════════ */
export default function AdminDashboard({ admin, onLogout }) {
  const [activeNav,     setActiveNav]     = useState('segments');
  const [segments,      setSegments]      = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [toggling,      setToggling]      = useState({});
  const [communicating, setCommunicating] = useState({});
  const [toast,         setToast]         = useState(null);
  const [orderAlerts,   setOrderAlerts]   = useState([]);
  const [themeKey,      setThemeKey]      = useState(() => localStorage.getItem('nb_admin_theme')||'light');

  const T = ADMIN_THEMES[themeKey];

  // Inject CSS vars + DM Sans whenever theme changes
  useEffect(() => {
    injectAdminThemeVars(T);
    localStorage.setItem('nb_admin_theme', themeKey);
    document.body.style.background = T.bg;
    document.body.style.fontFamily = "'DM Sans',-apple-system,sans-serif";

    // Inject global CSS overrides for sub-pages dark/light theme
    let el = document.getElementById('nb-admin-theme-style');
    if (!el) { el = document.createElement('style'); el.id = 'nb-admin-theme-style'; document.head.appendChild(el); }
    el.textContent = `
      .nb-admin-content, .nb-admin-content * { font-family: 'DM Sans',-apple-system,sans-serif !important; }
      .nb-admin-content { color: ${T.tx} !important; }
      .nb-admin-content > div { background: transparent !important; }
      .nb-admin-content [style*="background: '#fff'"],
      .nb-admin-content [style*='background: "#fff"'] { background: ${T.surf} !important; }
      .nb-admin-content input, .nb-admin-content select {
        background: ${T.surf2} !important;
        color: ${T.tx} !important;
        border-color: ${T.bdr2} !important;
      }
    `;
  }, [T, themeKey]);

  const toggleTheme = () => setThemeKey(k => k==='light'?'dark':'light');

  const showToast = (msg, type='success') => { setToast({msg,type}); setTimeout(()=>setToast(null),4000); };

  const handleNewOrder = useCallback((orderData) => {
    setOrderAlerts(prev => [...prev, orderData]);
  }, []);

  useOrderNotifications(handleNewOrder);

  const handleDismissAlerts = () => {
    const ids = orderAlerts.map(a=>a.orderId);
    setOrderAlerts([]);
    const token = localStorage.getItem('nb_admin_token');
    if (token && ids.length>0) fetch('/api/admin/notifications/seen',{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},body:JSON.stringify({order_ids:ids})}).catch(()=>{});
  };

  const handleViewOrders = () => { setActiveNav('orders'); handleDismissAlerts(); };

  const loadSegments = async () => {
    try { const res=await (await fetch('/api/admin/control/segments',{headers:{'Authorization':`Bearer ${localStorage.getItem('nb_admin_token')}`}})).json(); setSegments(res.segments||[]); }
    catch { showToast('Failed to load segments.','error'); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadSegments(); }, []);

  const handleToggle = async (exchange, segment, on) => {
    const key = `${exchange}-${segment}`;
    setToggling(t=>({...t,[key]:true}));
    try {
      await fetch('/api/admin/control/segments/toggle',{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('nb_admin_token')}`},body:JSON.stringify({exchange,segment,enable:!on,notes:''})}); 
      showToast(`${exchange} ${segment} ${!on?'enabled':'disabled'} successfully`);
      loadSegments();
    } catch(err) { showToast(err.message||'Failed.','error'); }
    finally { setToggling(t=>({...t,[key]:false})); }
  };

  const handleAlert = async (exchange, segment) => {
    const key = `${exchange}-${segment}`;
    if (!window.confirm(`Send Email + WhatsApp to all clients with open ${exchange} ${segment} positions?`)) return;
    setCommunicating(c=>({...c,[key]:true}));
    try {
      const res = await (await fetch('/api/admin/control/communicate',{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('nb_admin_token')}`},body:JSON.stringify({exchange,segment,send_email:true,send_whatsapp:true})})).json();
      showToast(`Sent to ${res.total_clients} clients`);
    } catch(err) { showToast('Communication failed.','error'); }
    finally { setCommunicating(c=>({...c,[key]:false})); }
  };

  const navTitles = {
    segments: { title:'Segment Control',       sub:'Manage exchange segments and client communications' },
    orders:   { title:'Square-Off Orders',      sub:'View and manage client sq-off requests'            },
    alerts:   { title:'Client Alerts',          sub:'Bulk communication history'                        },
    bfupload: { title:'B/F Position Upload',    sub:'Upload daily NSE FO and MCX carried-forward files' },
    reports:  { title:'Order Reports',          sub:'Download exchange-wise reports'                     },
    dealer:   { title:'Dealer Access',          sub:'SSO and dealer order management'                    },
    logs:     { title:'Audit Logs',             sub:'System activity and admin actions'                  },
    syslogs:  { title:'System Logs',            sub:'Complete audit trail for compliance'                },
    users:    { title:'User Management',        sub:'Admin and sub-user access control'                  },
    clients:  { title:'Client Upload',          sub:'Bulk upload clients via CSV file'                   },
    syncmon:  { title:'Sync Monitor',           sub:'DropCopy sync status and logs'                      },
  };
  const current = navTitles[activeNav]||navTitles.segments;
  const S = getAdminStyles(T);

  return (
    <AdminThemeContext.Provider value={{ themeKey, T, toggleTheme }}>
      <div style={{ display:'flex', minHeight:'100vh', background:T.bg, fontFamily:"'DM Sans',-apple-system,sans-serif" }}>

        {/* Order alert banner */}
        <OrderAlertBanner alerts={orderAlerts} onDismiss={handleDismissAlerts} onViewOrders={handleViewOrders}/>

        {/* Toast */}
        {toast && <div style={{...S.toast(toast.type)}}>{toast.msg}</div>}

        {/* Sidebar */}
        <Sidebar activeNav={activeNav} onNav={setActiveNav} admin={admin} pendingCount={orderAlerts.length} T={T}
          onLogout={()=>{ localStorage.removeItem('nb_admin_token'); localStorage.removeItem('nb_admin'); onLogout(); }}/>

        {/* Main */}
        <div style={{ marginLeft:210, flex:1, display:'flex', flexDirection:'column', minHeight:'100vh' }}>
          <Topbar title={current.title} subtitle={current.sub} admin={admin} T={T} themeKey={themeKey} toggleTheme={toggleTheme}/>

          <div className="nb-admin-content" style={{ padding:'20px 24px', flex:1, background:T.bg }}>
            {activeNav==='segments' && (
              loading
                ? <div style={{...S.empty}}>Loading segments...</div>
                : <SegmentControl segments={segments} onToggle={handleToggle} onAlert={handleAlert} toggling={toggling} communicating={communicating} T={T}/>
            )}
            {/* Keep components mounted to avoid reload delay on tab switch */}
            <div style={{display: activeNav==='orders'  ?'block':'none'}}><SqOffOrders/></div>
            <div style={{display: activeNav==='alerts'  ?'block':'none'}}><ClientAlerts/></div>
            <div style={{display: activeNav==='bfupload'?'block':'none'}}><BFUpload/></div>
            <div style={{display: activeNav==='reports' ?'block':'none'}}><OrderReports/></div>
            <div style={{display: activeNav==='dealer'  ?'block':'none'}}><DealerAccessPanel/></div>
            <div style={{display: activeNav==='logs'    ?'block':'none'}}><AuditLogs/></div>
            <div style={{display: activeNav==='syslogs' ?'block':'none'}}><SystemLogsPanel/></div>
            <div style={{display: activeNav==='syncmon' ?'block':'none'}}><SyncMonitor/></div>
            <div style={{display: activeNav==='users'   ?'block':'none'}}><UserManagement/></div>
            <div style={{display: activeNav==='clients' ?'block':'none'}}><ClientUpload/></div>
          </div>

          <div style={{ textAlign:'center', padding:'12px', fontSize:10, color:T.tx3, borderTop:`0.5px solid ${T.bdr}` }}>
            Navia Markets Ltd · RMS Admin Terminal · {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </AdminThemeContext.Provider>
  );
}